import styled from 'styled-components';
import { TOGGLE } from './floatingControls';

export const ToggleButton = styled.button`
  position: fixed;
  top: ${TOGGLE.desktop.top}px;
  right: ${TOGGLE.desktop.right}px;
  z-index: 1001;
  width: ${TOGGLE.desktop.size}px;
  height: ${TOGGLE.desktop.size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.cardBackground};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  }

  svg {
    width: 24px;
    height: 24px;
    color: ${({ theme }) => theme.colors.text};
    transition: transform 0.3s ease;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    top: ${TOGGLE.mobile.top}px;
    right: ${TOGGLE.mobile.right}px;
    width: ${TOGGLE.mobile.size}px;
    height: ${TOGGLE.mobile.size}px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &.sun {
    opacity: ${({ $isDark }) => ($isDark ? 0 : 1)};
    transform: ${({ $isDark }) => ($isDark ? 'rotate(90deg) scale(0)' : 'rotate(0deg) scale(1)')};
  }

  &.moon {
    opacity: ${({ $isDark }) => ($isDark ? 1 : 0)};
    transform: ${({ $isDark }) => ($isDark ? 'rotate(0deg) scale(1)' : 'rotate(-90deg) scale(0)')};
  }
`;
